<template>
  <div id>
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý Sản phẩm', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 pb-4 bg-lighter">
      <block :nobody="true" ref="bproduct" class="soft-control">
        <!-- @search="handleSearch" -->
        <control-panel
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @doEdit="handleUpdate"
          :noSearch="true"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
        ></control-panel>
        <b-card :no-body="true" class="p-2 mb-0">
          <b-tabs>
            <b-tab title="Sản phẩm" @click="typeSelected = 'ACTIVE'">
              <product
                @countCheckedChange="countCheckedChange"
                @specProductUnitSelected="specProductUnitSelected"
                @reloadProductInfo="reloadProductInfo"
                ref="productActive"
                type="ACTIVE"
              ></product>
            </b-tab>
            <b-tab title="Sản phẩm thử" @click="typeSelected = 'SAMPLE'">
              <product
                @tbRowClicked="productRowClicked"
                @specProductUnitSelected="specProductUnitSelected"
                @countCheckedChange="countCheckedChange"
                @reloadProductInfo="reloadProductInfo"
                ref="productSample"
                type="SAMPLE"
              ></product>
            </b-tab>
            <b-tab title="QL Diễn giải" @clic="typeSelected = 'REASON'">
              <Reason></Reason>
            </b-tab>
          </b-tabs>
        </b-card>
      </block>
      <block :nobody="true" ref="binfoProduct" class="soft-control mb-3">
        <b-row class=" p-2">
          <b-col md="12">
            <b-card :no-body="true" class="p-2 mb-0">
              <product-info @reloadProductInfo="reloadProductInfo" ref="productInfos"></product-info>
            </b-card>
          </b-col>
        </b-row>
      </block>
    </div>
    <event @doAdd="handleCreate" @doEdit="handleUpdate"></event>
  </div>
</template>
<script>
import Product from './__Product';
import Reason from './__Reason';
import ProductInfo from './__ProductInfo';
export default {
  name: 'product-manage',
  components: {
    Product,
    ProductInfo,
    Reason
  },
  data() {
    return {
      keyword: '',
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      typeSelected: 'ACTIVE',
      info: {},
      tableData: [],
      fields: []
    };
  },
  methods: {
    productTabSelect() {
      if (this.typeSelected == 'ACTIVE') return this.$refs.productActive;
      return this.$refs.productSample;
    },
    specProductUnitSelected(spectProductUnit, product) {
      this.$refs.productInfos.setData(product, spectProductUnit);
    },
    reloadProductInfo() {
      this.$refs.productInfos.fetchData();
    },
    handleSearch(keyword) {
      this.productTabSelect().handleSearch(this.keyword);
    },
    handleUpdate() {
      this.productTabSelect().handleUpdate();
    },
    handleCreate() {
      this.productTabSelect().handleCreate();
    },
    handleCopy() {
      this.productTabSelect().handleCopy();
    },
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      this.productTabSelect().handleDelete();
    },
    countCheckedChange(countChecked) {
      this.countChecked = countChecked;
    },
    productRowClicked(item) {
      this.info = item;
      // this.$refs.productInfos.setData(this.info);
    }
  },
  watch: {
    typeSelected: function() {
      this.countChecked = this.productTabSelect().countChecked;
      this.info = this.productTabSelect().info;
      //this.$refs.productInfos.setData(this.info);
    }
  }
};
</script>
<style lang="scss"></style>
